import DynamicList from './DynamicList'
export default DynamicList
